/*
  ml-campaign-modal — the campaign-aware exit modal (Campaign Modal board; Pass 3 Capture
  Modals G2). Configuration: #MlCampaignConfig, printed by snippets/ml-campaign-modal.

  WHICH PRODUCT, in order: the ad's promo_product (monthlees_attr_v1, written by
  assets/ml-attr-promo.js) while it is younger than ttlDays; the last product viewed this
  session; otherwise none (generic). The product is checked live through
  /products/<handle>?sections=ml-campaign-data: it must be visible and active, and its
  member price must be a real monthlees.member_price. Out of stock shows the out-of-stock
  version; a hidden product or one without a member price falls back to generic.

  TRIGGERS. Desktop: leaving through the top edge after 8 seconds on site. Touch: on a
  product page, whichever comes first: a fast scroll-up (>= 800 px/s) after passing half
  the page, 40 seconds without an add to cart, or the second product page view without
  one. No back-button trapping.

  NEVER while another dialog, drawer or menu is open, when a membership is in the cart,
  more than once a session, within dismissDays of a dismiss, or after an email was given
  (the ml_capture cookie).

  MEMBERS get no discount, code or email ask: a quiet "waiting at your member price" with
  Add to cart, and nothing at all without a product.

  An email, when given, goes to /apps/precision/lead with a source per version
  (exit_member_gap, exit_last_viewed, exit_generic, exit_first_order, exit_annual_gift) and
  the product's handle. The backend tags the Shopify customer, reads the product from Shopify,
  writes it to the ESP3 contact and subscribes it to that version's list (exitmembergap,
  exitlastviewed, exitgeneric, exitfirstorder, exitannualgift), whose automation sends the
  version's email (ml_exit_gap_1, ml_exit_generic_1, ml_first_order_code, ml_annual_gift_1).
*/
(function () {
  'use strict';
  if (window.MlCampaignModal) return;

  var cfgNode = document.getElementById('MlCampaignConfig');
  if (!cfgNode) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgNode.textContent);
  } catch (e) {
    return;
  }

  var DAY = 86400000;
  var root = null;
  var lastFocus = null;
  var busy = false;
  var current = null; // { variant, product, source, reason }
  var TRIAL = cfg.mode === 'trial'; // the membership pages: the trial exit modal (TX)

  // ---------- storage ----------
  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k);
      else window.localStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function hasCaptureCookie() {
    return /(?:^|;\s*)ml_capture=1/.test(document.cookie || '');
  }
  function setCaptureCookie() {
    document.cookie = 'ml_capture=1; path=/; max-age=' + 365 * 86400 + '; SameSite=Lax';
  }

  function blockedByFrequency() {
    if (TRIAL) {
      // TX: once per 7 days, whether it was dismissed or not.
      var tx = parseInt(ls('ml_tx_at'), 10);
      return !!(tx && Date.now() - tx < 7 * DAY);
    }
    if (hasCaptureCookie()) return true;
    if (ss('ml_cm_shown') === '1') return true;
    var d = parseInt(ls('ml_cm_dismissed_at'), 10);
    if (d && Date.now() - d < (cfg.dismissDays || 7) * DAY) return true;
    return false;
  }

  function track(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(event, props || {});
    } catch (e) {}
  }

  // ---------- money ----------
  function money(cents, format) {
    var f = format || '${{amount}}';
    var n = (cents || 0) / 100;
    function withDelims(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ---------- which product ----------
  function promoProduct() {
    var rec = null;
    try { rec = JSON.parse(ls('monthlees_attr_v1') || 'null'); } catch (e) {}
    if (!rec || !rec.promo_product) {
      try { rec = JSON.parse(ls('ml_promo_product') || 'null'); } catch (e) { rec = null; }
    }
    if (!rec || !rec.promo_product || !rec.promo_product_at) return null;
    var at = Date.parse(rec.promo_product_at);
    if (isNaN(at) || Date.now() - at > (cfg.ttlDays || 7) * DAY) return null;
    return rec.promo_product;
  }

  function audienceIsMemberIntent() {
    try {
      var rec = JSON.parse(ls('monthlees_attr_v1') || 'null');
      return !!(rec && rec.utm_campaign && /^member[-_]?intent/i.test(rec.utm_campaign));
    } catch (e) {
      return false;
    }
  }

  function fetchData(handle) {
    var url = handle
      ? '/products/' + encodeURIComponent(handle) + '?sections=ml-campaign-data'
      : '/?sections=ml-campaign-data';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('data ' + res.status);
        return res.json();
      })
      .then(function (map) {
        var html = map && map['ml-campaign-data'];
        if (!html) throw new Error('no data');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-ml-campaign-data]');
        return JSON.parse(node.textContent);
      });
  }

  function resolve() {
    if (TRIAL) {
      return fetchData(null).then(function (data) {
        return { data: data, product: null, source: null };
      });
    }
    var promo = promoProduct();
    var last = ss('ml_last_viewed');
    var source = promo ? 'promo' : last ? 'lastviewed' : null;
    var handle = promo || last || null;
    return fetchData(handle)
      .catch(function () {
        // A product that no longer exists: fall back to generic.
        source = null;
        return fetchData(null);
      })
      .then(function (data) {
        var p = data.product;
        if (p && !p.visible) p = null;
        if (!p) source = null;
        return { data: data, product: p, source: source };
      });
  }

  function chooseVariant(r) {
    var v = cfg.variants || {};
    var d = r.data;
    var p = r.product;
    if (d.membershipInCart) return null;
    if (TRIAL) return d.isMember ? null : 'trial';
    if (d.isMember) {
      if (p && p.available && v.member) return 'member';
      return null;
    }
    if (p && !p.available) return v.unavailable ? 'unavailable' : v.generic ? 'generic' : null;
    if (p && p.memberCents > 0 && p.memberCents < p.guestCents) {
      if (r.source === 'promo') {
        var secondShowing = ls('ml_cm_gap_seen') === '1';
        if (v.annualGift && (audienceIsMemberIntent() || secondShowing)) return 'annual-gift';
        if (v.coupon) return 'guest-coupon';
        if (v.gap) return 'guest-gap';
      }
      if (r.source === 'lastviewed' && v.lastviewed) return 'lastviewed';
    }
    return v.generic ? 'generic' : null;
  }

  // ---------- content ----------
  function content(variant, r) {
    var d = r.data;
    var p = r.product || {};
    var fmt = d.moneyFormat;
    var plans =
      d.monthlyCents && d.annualCents
        ? 'Membership: ' + money(d.monthlyCents, fmt) + '/month, or ' + money(d.annualCents, fmt) + '/year billed annually. Cancel anytime.'
        : '';
    var consent = 'By continuing, you agree to receive marketing emails from Monthlees. Unsubscribe anytime.';
    var saving = p.guestCents && p.memberCents ? 'You save ' + money(p.guestCents - p.memberCents, fmt) + ' on this product as a member.' : '';
    var toMembership = cfg.membershipsUrl + (p.handle ? '?product=' + encodeURIComponent(p.handle) : '');
    switch (variant) {
      case 'guest-gap':
      case 'lastviewed':
        return {
          img: p.image, imgAlt: p.imageAlt || p.title,
          badge: variant === 'guest-gap' ? 'From your ad' : 'You were looking at',
          eyebrow: 'Before you go',
          title: 'Get ' + p.title + ' at the member price',
          body: 'Add Monthlees Member Access to unlock member pricing on this product — and across the catalog.',
          price: { guest: money(p.guestCents, fmt), member: money(p.memberCents, fmt), save: saving },
          form: true, emailOptional: true, btn: 'Unlock member price', href: toMembership, express: 'paid',
          source: variant === 'guest-gap' ? 'exit_member_gap' : 'exit_last_viewed',
          fine: plans ? plans + ' ' + consent : consent
        };
      case 'guest-coupon':
        return {
          img: p.image, imgAlt: p.imageAlt || p.title, badge: 'From your ad', eyebrow: 'First order',
          title: (cfg.couponPercent || 10) + '% off your first order of ' + p.title,
          body: 'Enter your email and we’ll show your code for your guest order.',
          form: true, emailOptional: false, btn: 'Show my code', source: 'exit_first_order',
          fine: 'One use per customer, on guest orders. ' + consent
        };
      case 'annual-gift':
        return {
          img: p.image, imgAlt: p.imageAlt || p.title, badge: 'Free with annual', eyebrow: 'Members-only offer',
          title: p.title + ', free with an annual membership',
          body: 'Join annually and we’ll add it to your first order, with member pricing on everything after.',
          form: true, emailOptional: true, btn: 'Claim it with annual membership',
          href: cfg.annualGiftUrl + (cfg.annualGiftUrl.indexOf('?') === -1 ? '?' : '&') + 'gift=' + encodeURIComponent(p.handle),
          source: 'exit_annual_gift',
          fine: (d.annualCents ? 'Annual membership ' + money(d.annualCents, fmt) + '/year. Your pick is pre-selected on the next page. ' : '') + consent
        };
      case 'member':
        return {
          img: p.image, imgAlt: p.imageAlt || p.title, badge: 'Member', eyebrow: 'Welcome back',
          title: p.title + ' is waiting at your member price', body: '',
          price: p.memberCents > 0 ? { guest: money(p.guestCents, fmt), member: money(p.memberCents, fmt), save: 'Automatic savings applied at checkout.' } : null,
          form: false, btn: 'Add to cart', action: 'add', href: p.url, dismiss: 'Not now', fine: ''
        };
      case 'trial': {
        var days = d.trialDays || 7;
        var after = d.trialAfterCents ? money(d.trialAfterCents, fmt) + '/month' : '';
        return {
          img: (cfg.trial || {}).image, imgAlt: '', badge: days + ' days free', eyebrow: 'Not ready to commit?',
          title: 'Try membership free for ' + days + ' days.',
          body: 'Member pricing on every product from your first order. ' + money(0, fmt).replace(/\.00$/, '') + ' today' + (after ? ', then ' + after + ' after ' + days + ' days' : '') + '. Cancel anytime.',
          form: false, btn: 'Start my free week', action: 'trial', href: '/cart', express: 'trial',
          fine: 'Membership renews automatically. Cancel anytime.'
        };
      }
      case 'unavailable':
        return {
          img: p.image, imgAlt: p.imageAlt || p.title, imgGray: true, badge: 'Out of stock', eyebrow: 'Back soon',
          title: p.title + ' is out of stock right now',
          body: 'We’re restocking it. In the meantime, see what members buy most.',
          form: false, btn: 'Shop Best Sellers', href: cfg.bestSellersUrl, fine: ''
        };
      default: {
        var g = cfg.generic || {};
        var perMonth = d.annualCents ? money(Math.round(d.annualCents / 12), fmt) : '';
        var body = String(g.body || '');
        if (body.indexOf('{per_month}') !== -1) body = perMonth ? body.replace('{per_month}', perMonth) : '';
        return {
          img: g.image, imgAlt: g.imageAlt || '', eyebrow: 'Member pricing',
          title: g.title || 'Unlock member pricing on every product', body: body,
          form: true, emailOptional: true, btn: 'Show me member prices', href: cfg.membershipsUrl, express: 'paid',
          source: 'exit_generic', fine: consent
        };
      }
    }
  }

  // ---------- dialog ----------
  function ensureCss() {
    if (document.querySelector('link[data-ml-cm-css]') || !cfg.cssUrl) return Promise.resolve();
    return new Promise(function (resolveCss) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = cfg.cssUrl;
      l.setAttribute('data-ml-cm-css', '');
      l.onload = l.onerror = function () { resolveCss(); };
      document.head.appendChild(l);
    });
  }

  function build(c) {
    var id = 'MlCmTitle';
    var price = c.price
      ? '<div class="ml-cm__prices">' +
          '<div class="ml-cm__price"><span>Guest price</span><b><s>' + esc(c.price.guest) + '</s></b></div>' +
          '<div class="ml-cm__price is-member"><span>Member price</span><b>' + esc(c.price.member) + '</b></div>' +
        '</div>' +
        (c.price.save ? '<p class="ml-cm__save">' + esc(c.price.save) + '</p>' : '')
      : '';
    var form = c.form
      ? '<form class="ml-cm__form" novalidate data-ml-cm-form>' +
          '<label class="ml-cm__field"><span class="ml-cm__sr">Email address</span>' +
          '<input type="email" name="email" autocomplete="email" inputmode="email" placeholder="Email address"' + (c.emailOptional ? '' : ' required') + '></label>' +
          '<p class="ml-cm__err" data-ml-cm-err hidden></p>' +
          '<button type="submit" class="ml-cm__btn">' + esc(c.btn) + '</button>' +
        '</form>'
      : c.action === 'add' || c.action === 'trial'
      ? '<button type="button" class="ml-cm__btn" data-ml-cm-add>' + esc(c.btn) + '</button><p class="ml-cm__err" data-ml-cm-err hidden></p>'
      : '<a class="ml-cm__btn" href="' + esc(c.href) + '" data-ml-cm-go>' + esc(c.btn) + '</a>';
    return (
      '<div class="ml-cm__backdrop" data-ml-cm-close></div>' +
      '<div class="ml-cm__dialog" role="dialog" aria-modal="true" aria-labelledby="' + id + '">' +
        '<button type="button" class="ml-cm__x" aria-label="Close" data-ml-cm-close>×</button>' +
        '<div class="ml-cm__media">' +
          (c.img ? '<img src="' + esc(c.img) + '" alt="' + esc(c.imgAlt) + '"' + (c.imgGray ? ' class="is-gray"' : '') + '>' : '') +
          (c.badge ? '<span class="ml-cm__badge">' + esc(c.badge) + '</span>' : '') +
        '</div>' +
        '<div class="ml-cm__body">' +
          '<p class="ml-cm__eyebrow">' + esc(c.eyebrow) + '</p>' +
          '<h2 class="ml-cm__title" id="' + id + '" tabindex="-1">' + esc(c.title) + '</h2>' +
          (c.body ? '<p class="ml-cm__text">' + esc(c.body) + '</p>' : '') +
          price + form +
          '<button type="button" class="ml-cm__dismiss" data-ml-cm-close>' + esc(c.dismiss || 'No thanks') + '</button>' +
          (c.fine ? '<p class="ml-cm__fine">' + esc(c.fine) + '</p>' : '') +
        '</div>' +
      '</div>'
    );
  }

  function otherOverlayOpen() {
    var html = document.documentElement;
    if (/(^|\s)(monthlees-cart-drawer-open|ml-cart-drawer-lock|monthlees-header-mobile-open)(\s|$)/.test(html.className)) return true;
    var lockedBody = document.body && getComputedStyle(document.body).overflow === 'hidden';
    if (lockedBody || getComputedStyle(html).overflow === 'hidden') return true;
    var nodes = document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog[open]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (root && root.contains(n)) continue;
      if (n.hidden || n.closest('[hidden]')) continue;
      var r = n.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) continue;
      if (r.right <= 0 || r.left >= window.innerWidth || r.bottom <= 0 || r.top >= window.innerHeight) continue;
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0 || cs.display === 'none') continue;
      return true;
    }
    return false;
  }

  function open(c) {
    root = document.createElement('div');
    root.className = 'ml-cm';
    root.setAttribute('data-variant', current.variant);
    root.innerHTML = build(c);
    document.body.appendChild(root);
    lastFocus = document.activeElement;
    document.documentElement.classList.add('ml-cm-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    var title = root.querySelector('#MlCmTitle');
    if (title) title.focus({ preventScroll: true });
    bind(c);
  }

  function close(reason) {
    if (!root) return;
    var el = root;
    root = null;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('ml-cm-lock');
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    if (reason === 'dismiss') {
      ls('ml_cm_dismissed_at', String(Date.now()));
      track('campaign_modal_dismissed', { variant: current && current.variant });
    }
  }

  // Join CTAs open the Express membership modal (snippets/ml-express-membership-modal.liquid) when
  // Theme settings → Express membership → "Open Join links in the express modal" is on; with it
  // off there is no modal on the page and every CTA does exactly what it did before.
  function expressJoin(offer) {
    if (!offer || !window.MlExpressMembership || typeof window.MlExpressMembership.open !== 'function') return false;
    if (!document.querySelector('[data-ml-xm-modal]')) return false;
    close('done');
    window.setTimeout(function () { window.MlExpressMembership.open(offer); }, 0);
    return true;
  }

  function postLead(email, source, handle) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 4000) : null;
    return fetch(cfg.leadUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // The handle only: the backend reads the product and its prices from Shopify itself.
      body: JSON.stringify(handle ? { email: email, source: source, product_handle: handle } : { email: email, source: source }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || (data && data.ok === false)) throw data || {};
          return data;
        });
      })
      .finally(function () { if (timer) window.clearTimeout(timer); });
  }

  function showError(msg) {
    var e = root && root.querySelector('[data-ml-cm-err]');
    if (!e) return;
    e.textContent = msg;
    e.hidden = false;
  }

  function showCode() {
    var body = root && root.querySelector('.ml-cm__body');
    if (!body) return;
    body.innerHTML =
      '<p class="ml-cm__eyebrow">Your code</p>' +
      '<h2 class="ml-cm__title" id="MlCmTitle" tabindex="-1">' + esc(cfg.couponCode) + '</h2>' +
      '<p class="ml-cm__text">Enter it at checkout for ' + esc(String(cfg.couponPercent || 10)) + '% off your first guest order.</p>' +
      '<button type="button" class="ml-cm__btn" data-ml-cm-close-plain>Continue shopping</button>';
    var t = body.querySelector('#MlCmTitle');
    if (t) t.focus({ preventScroll: true });
  }

  function bind(c) {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ml-cm-close]')) {
        e.preventDefault();
        close('dismiss');
      } else if (t.closest('[data-ml-cm-close-plain]')) {
        e.preventDefault();
        close('done');
      } else if (t.closest('[data-ml-cm-go]')) {
        track('campaign_modal_clicked', { variant: current.variant });
      } else if (t.closest('[data-ml-cm-add]')) {
        e.preventDefault();
        if (busy) return;
        if (c.express && expressJoin(c.express)) {
          track('campaign_modal_clicked', { variant: current.variant, action: 'express_' + c.express });
          return;
        }
        busy = true;
        var p = current.product || {};
        var item = current.variant === 'trial'
          ? { id: cfg.trial.variantId, quantity: 1, selling_plan: cfg.trial.sellingPlanId }
          : { id: p.variantId, quantity: 1 };
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
          .then(function () {
            track('campaign_modal_clicked', { variant: current.variant, action: 'add_to_cart' });
            close('done');
            document.dispatchEvent(new CustomEvent('monthlees:cart-updated', { detail: { source: 'ml-cart-v2' } }));
            if (window.MonthleesCartDrawer && typeof window.MonthleesCartDrawer.open === 'function') window.MonthleesCartDrawer.open();
            else window.location.assign('/cart');
          })
          .catch(function () {
            window.location.assign(p.url || '/cart');
          })
          .finally(function () { busy = false; });
      }
    });

    var form = root.querySelector('[data-ml-cm-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var input = form.querySelector('input[name="email"]');
        var email = String((input && input.value) || '').trim();
        var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (email && !valid) {
          showError('Please enter a valid email address.');
          if (input) input.focus();
          return;
        }
        if (!email && !c.emailOptional) {
          showError('Please enter your email address.');
          if (input) input.focus();
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        busy = true;
        var step = email
          ? postLead(email, c.source, current.product && current.variant !== 'generic' ? current.product.handle : null).then(function () {
              setCaptureCookie();
              track('campaign_modal_email', { variant: current.variant, source: c.source });
              return true;
            })
          : Promise.resolve(false);
        step
          .then(function () {
            if (current.variant === 'guest-coupon') {
              showCode();
              return;
            }
            track('campaign_modal_clicked', { variant: current.variant, email: !!email });
            if (c.express && expressJoin(c.express)) return;
            window.location.assign(c.href);
          })
          .catch(function () {
            if (current.variant === 'guest-coupon') {
              showError('That didn’t go through. Please try again.');
              return;
            }
            // The email didn't reach us; the visitor still gets where they were going.
            if (c.express && expressJoin(c.express)) return;
            window.location.assign(c.href);
          })
          .finally(function () {
            busy = false;
            if (btn) btn.removeAttribute('aria-busy');
          });
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close('dismiss');
        return;
      }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'));
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // ---------- trigger ----------
  function trigger(reason) {
    if (root || busy || blockedByFrequency() || otherOverlayOpen()) return;
    busy = true;
    resolve()
      .then(function (r) {
        var variant = chooseVariant(r);
        if (!variant) return;
        if (blockedByFrequency() || otherOverlayOpen()) return;
        current = { variant: variant, product: r.product, source: r.source, reason: reason };
        var c = content(variant, r);
        return ensureCss().then(function () {
          if (root || otherOverlayOpen()) return;
          if (TRIAL) ls('ml_tx_at', String(Date.now()));
          else ss('ml_cm_shown', '1');
          if (variant === 'guest-gap') ls('ml_cm_gap_seen', '1');
          open(c);
          track('campaign_modal_shown', {
            variant: variant,
            trigger: reason,
            product_handle: r.product ? r.product.handle : null
          });
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function arm() {
    if (blockedByFrequency()) return;
    if (!ss('ml_cm_t0')) ss('ml_cm_t0', String(Date.now()));
    var t0 = parseInt(ss('ml_cm_t0'), 10) || Date.now();
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var atc = function () { return ss('ml_atc') === '1'; };

    if (TRIAL && !fine) {
      // TX on touch: scrolling back up after the plan block, or 30s without touching the page.
      var plans = document.querySelector('.ml-md, [data-ml-plan-block]');
      var passedPlans = false;
      var py = window.scrollY;
      var pt = Date.now();
      window.addEventListener(
        'scroll',
        function () {
          var y = window.scrollY;
          var t = Date.now();
          if (plans) {
            var r = plans.getBoundingClientRect();
            if (r.bottom < 0) passedPlans = true;
          } else if (y > window.innerHeight) {
            passedPlans = true;
          }
          var dt = t - pt;
          if (passedPlans && dt > 0 && dt < 250 && ((py - y) / dt) * 1000 >= 800) trigger('scroll_up');
          py = y;
          pt = t;
        },
        { passive: true }
      );
      var idle = null;
      var resetIdle = function () {
        if (idle) window.clearTimeout(idle);
        idle = window.setTimeout(function () { trigger('idle'); }, 30000);
      };
      ['scroll', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
        window.addEventListener(ev, resetIdle, { passive: true });
      });
      resetIdle();
      return;
    }

    if (fine) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.toElement) return;
        if (e.clientY > 0) return;
        if (Date.now() - t0 < 8000) return;
        trigger('exit_intent');
      });
      return;
    }

    if (cfg.pageType !== 'product') return;

    // (c) the second product page view without an add to cart
    if ((parseInt(ss('ml_pv_count'), 10) || 0) >= 2 && !atc()) {
      window.setTimeout(function () { if (!atc()) trigger('second_product_view'); }, 5000);
    }
    // (b) 40 seconds on a product page without an add to cart
    window.setTimeout(function () { if (!atc()) trigger('product_idle'); }, 40000);
    // (a) a fast scroll-up after passing half the page
    var passedHalf = false;
    var lastY = window.scrollY;
    var lastT = Date.now();
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        var t = Date.now();
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        if (docH > 0 && y / docH >= 0.5) passedHalf = true;
        var dt = t - lastT;
        if (passedHalf && dt > 0 && dt < 250 && lastY - y > 0 && ((lastY - y) / dt) * 1000 >= 800 && !atc()) {
          trigger('scroll_up');
        }
        lastY = y;
        lastT = t;
      },
      { passive: true }
    );
  }

  window.MlCampaignModal = {
    // For QA from the console: MlCampaignModal.preview() ignores the triggers and caps.
    preview: function () {
      ss('ml_cm_shown', '');
      ls('ml_cm_dismissed_at', null);
      ls('ml_tx_at', null);
      trigger('preview');
    },
    close: function () { close('done'); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
